export const getCompanyId = (proposalsByClient, proposal) =>
  (typeof proposalsByClient[proposal] !== 'string' &&
    proposalsByClient[proposal][0].company &&
    proposalsByClient[proposal][0].company.id) ||
  +proposalsByClient[proposal]
